import { useState } from 'react';

import RailEuropeErrorDialog from '~features/RailEuropeCommon/ErrorDialog';
import { useDetermineMobile } from '@myrealtrip/device-detect';
import useToast from '~hooks/useToast';
import { showErrorFeedback } from '~utils/pointToPointTicket/commonErrorMapper';

import type { Options as ToastOptions } from '~utils/commonToast';

const useErrorFeedback = () => {
  const isMobile = useDetermineMobile();
  const toast = useToast();

  const [errorDialogInfo, setErrorDialogInfo] = useState<{
    open: boolean;
    title: string | undefined;
    message: string;
    buttonText: string | undefined;
  }>({
    open: false,
    title: undefined,
    message: '',
    buttonText: undefined,
  });

  const handleErrorFeedback = (
    error: unknown,
    feedbackOptions?: Omit<ToastOptions, 'message'> & { errorMessage?: string },
  ) => {
    showErrorFeedback({
      error,
      toast,
      isMobile,
      feedbackOptions,
      onShowErrorDialog: (msg, title, buttonText) =>
        setErrorDialogInfo({ open: true, message: msg, title, buttonText }),
    });
  };

  const errorDialog = errorDialogInfo.open ? (
    <RailEuropeErrorDialog
      description={errorDialogInfo.message}
      title={errorDialogInfo.title}
      buttonText={errorDialogInfo.buttonText}
      onClose={() =>
        setErrorDialogInfo({ open: false, title: undefined, message: '', buttonText: undefined })
      }
    />
  ) : null;

  return { errorDialog, handleErrorFeedback };
};

export default useErrorFeedback;
